import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class FlowSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.FlowSensor,
    });
  }
}
